/**
 * Получение ширины текста в px
 * @param text - строка
 * @param fontSize - размер строки в pt
 */
export const getWordWidth = (text: string, fontSize = 12) => {
    const parent = document.body
    const span = document.createElement("span");
    span.style.position = "fixed";
    span.innerHTML = text
    span.style.fontSize = `${fontSize}px`;
    parent.appendChild(span);
    const width = span.getBoundingClientRect().width;
    parent.removeChild(span);

    return width;
};
